import React,{useState,useEffect,useRef}from"react";
import{Search,X,ChevronRight}from"lucide-react";
import{fmtDate,isOverdue}from"../config";
import{StaBadge,PriBadge}from"./UI";

export default function SearchModal({tasks,onClose,onSelect}){
  const[q,setQ]=useState("");
  const ref=useRef(null);
  useEffect(()=>{
    ref.current?.focus();
    const h=e=>{if(e.key==="Escape")onClose();};
    document.addEventListener("keydown",h);
    return()=>document.removeEventListener("keydown",h);
  },[onClose]);
  const lq=q.trim().toLowerCase();
  const results=lq.length<2?[]:tasks.filter(t=>
    t.title.toLowerCase().includes(lq)||
    (t.desc||"").toLowerCase().includes(lq)||
    (t.notes||"").toLowerCase().includes(lq)||
    (t.tags||[]).some(g=>g.toLowerCase().includes(lq))
  ).slice(0,25);
  return(
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-16 px-4" style={{background:"rgba(0,0,0,0.45)"}} onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden" onClick={e=>e.stopPropagation()}>
        <div className="flex items-center gap-3 px-4 py-3 border-b border-slate-200">
          <Search size={16} className="text-slate-400 shrink-0"/>
          <input ref={ref} value={q} onChange={e=>setQ(e.target.value)} placeholder="Search tasks by title, description, tags…" autoComplete="off" className="flex-1 text-sm outline-none placeholder-slate-400"/>
          <button onClick={onClose} title="Close search" className="text-slate-400 hover:text-slate-600 p-0.5"><X size={15}/></button>
        </div>
        <div className="max-h-[420px] overflow-y-auto">
          {lq.length<2
            ?<p className="text-xs text-slate-400 text-center py-6">Type at least 2 characters to search</p>
            :results.length===0
              ?<p className="text-sm text-slate-400 text-center py-8">No results for "<strong>{q}</strong>"</p>
              :<div className="divide-y divide-slate-100">
                {results.map(t=>(
                  <button key={t.id} onClick={()=>{onSelect(t.id);onClose();}} className="w-full text-left px-4 py-3 hover:bg-slate-50 flex items-center gap-3">
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium truncate">{t.title}</p>
                      <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                        <StaBadge sta={t.sta}/><PriBadge pri={t.pri}/>
                        {t.dueDate&&<span className="text-xs text-slate-400">Due {fmtDate(t.dueDate)}</span>}
                        {isOverdue(t)&&<span className="text-xs text-red-500 font-semibold">Overdue</span>}
                      </div>
                    </div>
                    <ChevronRight size={13} className="text-slate-300 shrink-0"/>
                  </button>
                ))}
              </div>
          }
        </div>
        <div className="px-4 py-2 border-t border-slate-100 flex items-center gap-3 text-xs text-slate-400">
          <span><kbd className="px-1.5 py-0.5 bg-slate-100 rounded font-mono">Esc</kbd> close · <kbd className="px-1.5 py-0.5 bg-slate-100 rounded font-mono">Ctrl K</kbd> reopen</span>
          {results.length>0&&<span className="ml-auto">{results.length} result{results.length!==1?"s":""}</span>}
        </div>
      </div>
    </div>
  );
}
